import styled from "styled-components";
import { InputHint } from "./../InputField/InputHint";

export const TextAreaHint = styled(InputHint)``;

TextAreaHint.displayName = "TextAreaHint";
